/*
 * @Author: 姚阳子 yaoyangzi@linhuiba.com
 * @Date: 2023-05-15 17:05:26
 * @LastEditors: 姚阳子 yaoyangzi@linhuiba.com
 * @LastEditTime: 2023-05-15 17:18:59
 * @FilePath: /locationpms-pc/src/router/index.ts
 * @Description:
 *
 *
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import { routeClearUp } from '../common/helpers/import-aysnc';
import routerControl from './control'; // 路由控制器
import { microRoutes } from './micro';
import crmRouter from './crm/crm';
import adminRouter from './crm/admin';
import biRouter from './crm/bi';
import oaRouter from './crm/oa';
import userRouter from './crm/user';
function setRoute(routeName, pageName, config) {
    return routeClearUp(routeName, pageName, config);
}
/* 页面路由自动生成 */
var pageList = process.env.PAGE_LIST;
var routes = [];
if (pageList && pageList.length) {
    pageList.forEach(function (page) {
        var currentPageConfig = require("../views/" + page.relativePath + "/page.config.ts").default;
        var relativePath = page.relativePath.split('/pages/');
        var routeName = relativePath[0];
        var pageName = relativePath[1];
        routes.push(setRoute(routeName, pageName, currentPageConfig));
    });
}
Vue.use(VueRouter);
var createRouter = function () { return new VueRouter({
    mode: 'history',
    routes: routes.concat(microRoutes, adminRouter, biRouter, crmRouter, oaRouter, userRouter)
}); };
var router = createRouter();
routerControl(router);
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    var newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}
export default router;
export var asyncRouterMap = [
    { type: 'crm', router: crmRouter },
    { type: 'bi', router: biRouter },
    { type: 'oa', router: oaRouter },
    { type: 'manage', router: adminRouter }
];
